/**
 * Публичная ссылка на статус заказа: /order-status/<hash>, где hash — 32 hex-символа
 * и фактически токен доступа к заказу.
 */
const ORDER_STATUS_HASH = /(\/order-status\/)[a-f0-9]{32}/g;

/**
 * Заменяет хэш заказа на плейсхолдер, чтобы приватная ссылка не уходила
 * во внешние сервисы (Яндекс.Метрика, Sentry).
 */
export const maskOrderStatusLinks = (value?: string | null) => (
  typeof value === 'string' ? value.replace(ORDER_STATUS_HASH, '$1:hash') : value
);

/** true, если строка содержит ссылку на публичную страницу статуса заказа. */
export const hasOrderStatusHash = (value?: string | null) => (
  typeof value === 'string' && value !== maskOrderStatusLinks(value)
);
